<template>
  <v-dialog :value="value" width="520" persistent class="z5" @click:outside="closeModal">
    <v-card>
      <v-card-title class="text-h6 white--text third py-4">
        <span class="flex-grow-1 text-center font-weight-bold">Soin(s) prévu(s) aujourd'hui</span>
      </v-card-title>

      <v-card-text class="pt-6 pb-2">
        <p class="text-subtitle-1 font-weight-bold mb-2">
          Les chevaux suivants ont des soins prévus aujourd'hui :
        </p>
        <ul class="daily-soins-list redScroll">
          <li v-for="(label, i) in horsesSessions" :key="i" class="font-weight-bold text-body-1">
            <v-icon color="black" size="8" class="mr-1">mdi-circle</v-icon>
            {{ label }}
          </li>
        </ul>
      </v-card-text>

      <v-card-actions class="d-flex justify-space-around pa-4">
        <v-btn
          outlined
          rounded
          color="third"
          class="third--text px-4"
          @click="closeModal"
        >
          <v-icon left color="third" size="22">
            mdi-arrow-u-left-top
          </v-icon>
          FERMER
        </v-btn>
        <v-btn
          outlined
          rounded
          color="third"
          class="third--text px-4"
          @click="openSoinsListing"
        >
          SOINS
          <v-icon right color="third" size="22">
            mdi-file-table
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed } from '@vue/composition-api';
import { format, fromUnixTime } from 'date-fns';
import store from '@/store';
import router from '@/router';

export default {
  name: 'DailySoinsWarningModal',
  props: {
    value: { type: Boolean, default: false },
    items: { type: Array, default: () => [] }
  },
  setup (props, { emit }) {
    const closeModal = () => {
      emit('closeModal');
    };

    const openSoinsListing = () => {
      router.push({ name: 'TreatmentsListing' });
    };

    const horsesSessions = computed(() => {
      const horsesSessions = [];
      (props.items || []).map(session => {
        const sessionStart = format(fromUnixTime(session.start_time), "HH'h'mm");
        (session.horses || []).map(horse => {
          const horseDetail = store.getters.horse(horse.uuid);
          horsesSessions.push(`${horseDetail.wtitle} (${sessionStart})`);
        });
      });
      return horsesSessions;
    });

    return { closeModal, horsesSessions, openSoinsListing };
  }
};
</script>

<style scoped>
  .daily-soins-list {
    max-height: 240px;
    overflow-y: auto;
  }
</style>